/**
 * @description 通用配置
 */
const platform = require('./platform')
const mode = process.env.VUE_APP_MODE;

const setting = {
  // 平台配置
  platform,
  // 域名
  domainName: mode === 'gk' ? platform.baseUrl + '/23q' : platform.baseUrl,
  // 接口地址
  baseUrl: platform.baseUrl + platform.baseUrlSuffix,
  // 登陆地址
  loginAddress: platform.baseUrl + '/login',
  // 登陆失效回调地址
  callbackUrl: platform.callbackUrl,
}
console.log(setting, 'setting')
module.exports = setting
